import {NEXT_STEP, PREV_STEP, UPDATE_STEP_DATA, FINAL_STEP, FIRST_STEP} from "../actions/actions";

const initialState = {
    currentStep: 0,
    countSteps: 13,
    // clickCount: 0,
    stepsData: [
        {
            stepNumber: 1,
            checkBoxValues: [false, false, false, false, false, false]
        },
        {
            stepNumber: 2,
            inputValue: ""
        },
        {
            stepNumber: 3,
            inputNumber1: "",
            inputNumber2: "",
            // isFade: 0,
        },
        {
            stepNumber: 4,
            inputNumber1: "",
            inputNumber2: "",
            // isFade: 0,
        },
        {
            stepNumber: 5,
            inputNumber1: "",
            inputNumber2: "",
        },
        {
            stepNumber: 6,
            answer: false
        },
        {
            stepNumber: 7,
            inputNumber1: "",
            inputNumber2: "",
        },
        {
            stepNumber: 8,
            inputNumber1: "",
            inputNumber2: "",
            inputNumber3: "",
            inputNumber4: "",
        },
        {
            stepNumber: 10,
            inputNumber1: "",
            inputNumber2: "",
        },
 
        {
            stepNumber: 11,
            inputNumber1: "",
            inputNumber2: "",
        }
    ]
};

export const mainReducer = (state = initialState, action) => {
    switch (action.type) {
        case NEXT_STEP: {
            if (state.currentStep < state.countSteps) {
                return {
                    ...state,
                    currentStep: state.currentStep + 1
                }
            }
            return state;
        }
        case PREV_STEP: {
            const answer = state.stepsData[6].answer;
            if (!answer && state.currentStep === 10) {
                return {
                    ...state,
                    currentStep: 6
                }
            }
            if (state.currentStep > 0) {
                return {
                    ...state,
                    currentStep: state.currentStep - 1
                }
            }
            return state;
        }
        case UPDATE_STEP_DATA: {
            return {
                ...state,
                stepsData: state.stepsData.map(stepData => stepData.stepNumber === action.stepNumber ? action.stepData : stepData)
            }
        }
        case FINAL_STEP: {
            return {
                ...state,
                currentStep: 9
            }
        }
        case FIRST_STEP: {
            return {
                ...state,
                currentStep: 0
            }
        }
        default: {
            return state;
        }
    }
};
